// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"f6499fea","787":"7a0228df"}[chunkId] + ".chunk.js";
};